<div
  class="user-details"
  [class.no-padding]="noPadding$ | async">
  <div class="details-list">
    <div
      *ngFor="let detail of detailList$ | async; let i = index"
      class="details-item"
      [attr.data-cy]="'user-list-item-detail-' + detail.label"
      [class.col-is-even]="!((i + 1) % 2)"
      [class.col-2]="!((i - 1) % 3) || i === 1"
      [class.col-3]="!((i + 1) % 3)">
      <mat-icon
        matListIcon
        [svgIcon]="detail.icon || 'human-male-female'"></mat-icon>
      <p matLine>
        {{ detail.value }}
      </p>
    </div>
    <div
      *ngIf="(customerInformation$ | async)?.tags as tags"
      class="details-item"
      data-cy="user-list-item-detail-tags">
      <mat-icon
        matListIcon
        svgIcon="sell"></mat-icon>
      <mat-chip-list>
        <mat-chip *ngFor="let tag of tags">
          {{ tag.displayName }}
        </mat-chip>
      </mat-chip-list>
    </div>
  </div>
  <ng-container
    *ngIf="
      (customerInformation$ | async)?.files ||
      (invitee$ | async)?.personalData?.files as files
    ">
    <div
      class="file-download grid-col mt-3"
      *ngIf="files?.length">
      <button
        style="margin-bottom: 10px"
        type="button"
        (click)="$event.stopPropagation(); downloadCV(files[0])"
        class="outline-pill-button icon-left">
        <mat-icon
          *ngIf="(progressbarValue$ | async) === 100"
          class="color-success"
          svgIcon="check"></mat-icon>
        {{ ("downloadDossier" | i18n) || "Dossier herunterladen" }}
      </button>
      <mat-progress-bar
        *ngIf="isDownloading$ | async"
        mode="determinate"
        [value]="progressbarValue$ | async"></mat-progress-bar></div
  ></ng-container>
</div>
